"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var InputCombobox_component_exports = {};
__export(InputCombobox_component_exports, {
  UseInputComboboxCtx: () => UseInputComboboxCtx,
  default: () => InputCombobox_component_default
});
module.exports = __toCommonJS(InputCombobox_component_exports);
var import_react = __toESM(require("react"));
var import_debounce = __toESM(require("lodash/debounce"));
var import_baseTheme = __toESM(require("../../../themes/baseTheme"));
var import_useOnClickOutside = require("../../../utils/useOnClickOutside/useOnClickOutside.hook");
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_comboboxHelperUtils = require("../../../utils/comboboxHelperUtils");
var import_Icon = require("../../atoms/Icon/Icon.component");
var import_ComboboxListBox = require("../../atoms/ComboboxListBox/ComboboxListBox.component");
var import_InputCombobox = require("./InputCombobox.styled");
var import_Option = require("./Option.component");
var import_AllOptions = require("./AllOptions.component");
var import_utils = require("./utils");
var _excluded = ["disabled", "borderLess", "darkMode", "placeholder", "multiSelect", "required", "error", "errorText", "selectedLabelSingular", "selectedLabelPlural", "isListboxPagination"];
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r))
    return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var SearchComboboxContext = /* @__PURE__ */ (0, import_react.createContext)(void 0);
var UseInputComboboxCtx = function UseInputComboboxCtx2() {
  var ctx = (0, import_react.useContext)(SearchComboboxContext);
  if (!ctx)
    throw new Error("This must be used whitin <SearchComboboxSelect> component");
  return ctx;
};
var InputCombobox = function InputCombobox2(_ref) {
  var _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$borderLess = _ref.borderLess, borderLess = _ref$borderLess === void 0 ? false : _ref$borderLess, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, _ref$placeholder = _ref.placeholder, placeholder = _ref$placeholder === void 0 ? "Select an option" : _ref$placeholder, _ref$multiSelect = _ref.multiSelect, multiSelect = _ref$multiSelect === void 0 ? false : _ref$multiSelect, _ref$required = _ref.required, required = _ref$required === void 0 ? false : _ref$required, _ref$error = _ref.error, error = _ref$error === void 0 ? false : _ref$error, _ref$errorText = _ref.errorText, errorText = _ref$errorText === void 0 ? "Error" : _ref$errorText, _ref$selectedLabelSin = _ref.selectedLabelSingular, selectedLabelSingular = _ref$selectedLabelSin === void 0 ? "option" : _ref$selectedLabelSin, _ref$selectedLabelPlu = _ref.selectedLabelPlural, selectedLabelPlural = _ref$selectedLabelPlu === void 0 ? "options" : _ref$selectedLabelPlu, _ref$isListboxPaginat = _ref.isListboxPagination, isListboxPagination = _ref$isListboxPaginat === void 0 ? false : _ref$isListboxPaginat, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react.useState)(false), _useState2 = _slicedToArray(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
  var _useState3 = (0, import_react.useState)(props.defaultSelected !== void 0 ? props.defaultSelected : []), _useState4 = _slicedToArray(_useState3, 2), selected = _useState4[0], setSelected = _useState4[1];
  var _useState5 = (0, import_react.useState)(false), _useState6 = _slicedToArray(_useState5, 2), isAllSelected = _useState6[0], setIsAllSelected = _useState6[1];
  var _useState7 = (0, import_react.useState)(false), _useState8 = _slicedToArray(_useState7, 2), inputActive = _useState8[0], setInputActive = _useState8[1];
  var _useState9 = (0, import_react.useState)(-1), _useState10 = _slicedToArray(_useState9, 2), itemPosition = _useState10[0], setItemPosition = _useState10[1];
  var _useState11 = (0, import_react.useState)(""), _useState12 = _slicedToArray(_useState11, 2), filterVal = _useState12[0], setFilterVal = _useState12[1];
  var _useState13 = (0, import_react.useState)(false), _useState14 = _slicedToArray(_useState13, 2), showFilterVal = _useState14[0], setShowFilterVal = _useState14[1];
  var _useState15 = (0, import_react.useState)([]), _useState16 = _slicedToArray(_useState15, 2), filteredChildren = _useState16[0], setFilteredChildren = _useState16[1];
  var inputRef = (0, import_react.useRef)(null);
  var listboxRef = (0, import_react.useRef)(null);
  var containerRef = (0, import_react.useRef)(null);
  var _useState17 = (0, import_react.useState)(null), _useState18 = _slicedToArray(_useState17, 2), activeDescendant = _useState18[0], setActiveDescendant = _useState18[1];
  var _useState19 = (0, import_react.useState)(true), _useState20 = _slicedToArray(_useState19, 2), firstRender = _useState20[0], setFirstRender = _useState20[1];
  var _useState21 = (0, import_react.useState)(false), _useState22 = _slicedToArray(_useState21, 2), selection = _useState22[0], setSelection = _useState22[1];
  var IDLIST = {
    input_id: (0, import_comboboxHelperUtils.computedId)("input-search", props.id),
    search_label: (0, import_comboboxHelperUtils.computedId)("search-label", props.id),
    combobox_id: (0, import_comboboxHelperUtils.computedId)("search-combobox-list", props.id),
    error: (0, import_comboboxHelperUtils.computedId)("error", props.id)
  };
  var selectAllItems = function selectAllItems2() {
    var _listboxRef$current;
    var allItems = [];
    var options = (_listboxRef$current = listboxRef.current) === null || _listboxRef$current === void 0 ? void 0 : _listboxRef$current.querySelectorAll('li[role="option"]');
    var childFlat = import_react.Children.toArray(props.children).flat();
    setIsAllSelected(!isAllSelected);
    if (isAllSelected) {
      setSelected([]);
    } else {
      for (var i = 0; i < options.length; i += 1) {
        var child = childFlat[i].props;
        if (!child.disabled) {
          if (child.value === void 0) {
            allItems.push("allOptions");
          } else {
            allItems.push(childFlat[i].props.value);
          }
        }
      }
      setSelected(allItems);
      if (props.onSelect)
        props.onSelect(allItems);
    }
  };
  var dataContext = (0, import_react.useMemo)(function() {
    return {
      open,
      setOpen,
      id: props.id,
      selected,
      setSelected,
      itemPosition,
      setItemPosition,
      multiSelect,
      selectAllItems,
      isAllSelected,
      setIsAllSelected,
      maxVisibleChars: props.maxVisibleChars,
      selection,
      setSelection
    };
  }, [open, props.id, selected, multiSelect, itemPosition, isAllSelected, props.maxVisibleChars]);
  var filterItems = function filterItems2(selectedItem, value) {
    return selectedItem.filter(function(item) {
      return item !== value && item !== "allOptions";
    });
  };
  var listboxSelection = function listboxSelection2(currentOption) {
    var isSelected = selected.includes(currentOption.value);
    if (multiSelect) {
      if (isSelected && selected.length > 0 && currentOption.value !== "allOptions") {
        if (isAllSelected)
          setIsAllSelected(!isAllSelected);
        setSelected(filterItems(selected, currentOption.value));
      } else if (currentOption.value === "allOptions") {
        selectAllItems();
      } else {
        setSelected([currentOption.value].concat(_toConsumableArray(selected)));
      }
    } else if (!isSelected) {
      setSelected([currentOption.value]);
    }
  };
  var setListboxOpenAndFocus = function setListboxOpenAndFocus2(isOpen) {
    setOpen(isOpen);
    setTimeout(function() {
      return listboxRef.current.focus();
    }, 50);
  };
  var setInputFocus = function setInputFocus2() {
    inputRef.current.focus();
    setInputActive(true);
  };
  var setCloseAndInputFocus = function setCloseAndInputFocus2() {
    setOpen(false);
    setActiveDescendant(null);
    inputRef.current.focus();
  };
  var createSetFilteredChildren = function createSetFilteredChildren2() {
    var filtered = [];
    import_react.Children.forEach(props.children, function(child) {
      var childHasChildren = Array.isArray(child.props.children);
      var childText = childHasChildren ? (0, import_utils.extractChildString)(child.props.children).toUpperCase() : child.props.children.toUpperCase();
      if (childText.includes(filterVal.toUpperCase())) {
        filtered.push(/* @__PURE__ */ (0, import_react.cloneElement)(child, {
          key: child.id
        }));
      }
    });
    setFilteredChildren(filtered);
    if (filtered.length) {
      setItemPosition(-1);
      filtered.forEach(function(option, idx) {
        if (option.props.value === selected[0]) {
          setItemPosition(idx);
        }
      });
    }
  };
  (0, import_react.useEffect)(function() {
    if (isListboxPagination || firstRender) {
      if (props.defaultSelected) {
        var values = import_react.Children.toArray(props.children).map(function(child) {
          return /* @__PURE__ */ (0, import_react.isValidElement)(child) ? child.props.value : null;
        });
        var validSelectedValues = props.defaultSelected.filter(function(value) {
          return values.indexOf(value) !== -1;
        });
        if (validSelectedValues.length) {
          setSelected(_toConsumableArray(validSelectedValues));
        }
      }
      setFirstRender(false);
    }
  }, [props.defaultSelected]);
  (0, import_react.useEffect)(function() {
    var options = (0, import_utils.getOptionItems)(listboxRef);
    if (options && options.length) {
      var _options$itemPosition;
      setActiveDescendant((_options$itemPosition = options[itemPosition]) === null || _options$itemPosition === void 0 ? void 0 : _options$itemPosition.id);
    }
  }, [itemPosition, open]);
  (0, import_react.useEffect)(function() {
    var hasAllOptions;
    var options = import_react.Children.toArray(props.children);
    if (options) {
      options.forEach(function(item) {
        if (/* @__PURE__ */ (0, import_react.isValidElement)(item) && item.props.value === "allOptions") {
          hasAllOptions = true;
        }
      });
    }
    setShowFilterVal(false);
    if (props.onSelect && selection) {
      if (isAllSelected && selected.length < (options === null || options === void 0 ? void 0 : options.length)) {
        var deleteAllOption = selected.filter(function(item) {
          return item !== "allOptions";
        });
        props.onSelect(deleteAllOption);
      }
      if (hasAllOptions && !isAllSelected && selected.length === (options === null || options === void 0 ? void 0 : options.length) - 1) {
        props.onSelect(["allOptions"].concat(_toConsumableArray(selected)));
      }
      if (hasAllOptions && !isAllSelected && selected.length !== (options === null || options === void 0 ? void 0 : options.length) - 1) {
        props.onSelect(selected);
      }
      if (!hasAllOptions) {
        props.onSelect(selected);
      }
    }
    setSelection(false);
    var optionsWithoutAllOptions = (options === null || options === void 0 ? void 0 : options.length) - 1;
    if (hasAllOptions && selected.length === optionsWithoutAllOptions && !selected.includes("allOptions")) {
      setIsAllSelected(true);
      setSelected(["allOptions"].concat(_toConsumableArray(selected)));
    }
    if (selected.length < (options === null || options === void 0 ? void 0 : options.length) && selected.includes("allOptions")) {
      var deletedAllOptions = selected.filter(function(item) {
        return item !== "allOptions";
      });
      setIsAllSelected(false);
      setSelected(deletedAllOptions);
    }
  }, [selected]);
  (0, import_react.useEffect)(function() {
    if (filterVal.length) {
      createSetFilteredChildren();
    } else {
      setFilteredChildren([]);
    }
  }, [filterVal]);
  (0, import_useOnClickOutside.useOnClickOutside)(containerRef, function() {
    setActiveDescendant(null);
    setInputActive(!!inputRef.current.value);
    setOpen(false);
    setFilterVal("");
    setShowFilterVal(false);
    setFilteredChildren([]);
  });
  (0, import_useOnKeydown.useOnKeydown)(inputRef, function(keyList, ev) {
    var ArrowDown = keyList.ArrowDown, ArrowUp = keyList.ArrowUp, Escape = keyList.Escape, Alt = keyList.Alt, Tab = keyList.Tab;
    if (Escape) {
      setFilterVal("");
      if (open) {
        setCloseAndInputFocus();
        ev.stopPropagation();
      } else {
        setSelected([]);
        if (inputRef.current.value.length > 0 || selected.length > 0) {
          ev.stopPropagation();
        }
      }
    }
    if (Alt && ArrowDown) {
      setItemPosition(-1);
      setOpen(true);
    }
    if (ArrowDown && !Alt || ArrowUp) {
      setListboxOpenAndFocus(true);
      var options = (0, import_utils.getOptionItems)(listboxRef);
      var pos = ArrowUp ? options.length - 1 : 0;
      setItemPosition(pos);
      (0, import_comboboxHelperUtils.defineScrollBehavior)(listboxRef.current, options, pos);
    }
    if (Tab && open)
      setOpen(false);
  });
  (0, import_useOnKeydown.useOnKeydown)(listboxRef, function(keyList, ev) {
    ev.stopPropagation();
    var Enter = keyList.Enter, Escape = keyList.Escape, ArrowDown = keyList.ArrowDown, ArrowUp = keyList.ArrowUp, ArrowLeft = keyList.ArrowLeft, ArrowRight = keyList.ArrowRight, Home = keyList.Home, End = keyList.End, Tab = keyList.Tab;
    var options = (0, import_utils.getOptionItems)(listboxRef);
    if (Escape)
      setCloseAndInputFocus();
    if (Tab && open)
      setOpen(false);
    if (ArrowLeft || ArrowRight)
      setInputFocus();
    if (ArrowDown || ArrowUp) {
      var pos = ArrowUp ? itemPosition - 1 : itemPosition + 1;
      if (pos < 0) {
        pos = options.length - 1;
      }
      if (pos >= options.length) {
        pos = 0;
      }
      setItemPosition(pos);
      (0, import_comboboxHelperUtils.defineScrollBehavior)(listboxRef.current, options, pos);
    }
    if (Enter) {
      setSelection(true);
      var currentOption = (filteredChildren.length ? filteredChildren[itemPosition] : props.children[itemPosition]).props;
      if (!currentOption.disabled) {
        listboxSelection(currentOption);
        if (!multiSelect) {
          setCloseAndInputFocus();
        }
      }
    }
    if (Home || End) {
      var position = Home ? 0 : options.length - 1;
      setItemPosition(position);
      (0, import_comboboxHelperUtils.defineScrollBehavior)(listboxRef.current, options, position);
    }
  });
  var searchOnType = function searchOnType2(inputValue) {
    setShowFilterVal(true);
    setFilterVal(inputValue);
  };
  var debounceFn = (0, import_react.useCallback)((0, import_debounce.default)(searchOnType, 20), []);
  var openMemo = (0, import_react.useCallback)(function() {
    return setOpen(true);
  }, [open]);
  var handleInputChange = function handleInputChange2(ev) {
    openMemo();
    debounceFn(ev.target.value);
  };
  var getSelectedValue = function getSelectedValue2() {
    var customSelectedValue = "";
    if (multiSelect) {
      if (props.handleSelection) {
        var selectedOptionsFullInfo = import_react.Children.toArray(props.children).filter(function(child) {
          if (/* @__PURE__ */ (0, import_react.isValidElement)(child)) {
            return selected.indexOf(child.props.value) !== -1;
          }
          return false;
        }).map(function(child) {
          return /* @__PURE__ */ (0, import_react.isValidElement)(child) ? child.props : null;
        });
        customSelectedValue = props.handleSelection(selectedOptionsFullInfo) || "";
        return customSelectedValue;
      }
      if (selected.includes("allOptions")) {
        var _Children$toArray$fil = import_react.Children.toArray(props.children).filter(function(child) {
          if (/* @__PURE__ */ (0, import_react.isValidElement)(child)) {
            return child.props.value === selected[0];
          }
          return false;
        }), _Children$toArray$fil2 = _slicedToArray(_Children$toArray$fil, 1), _selectedOptionFullInfo = _Children$toArray$fil2[0];
        return /* @__PURE__ */ (0, import_react.isValidElement)(_selectedOptionFullInfo) ? _selectedOptionFullInfo.props.children : selected[0];
      }
      var selectedLabel = selected.length > 1 ? selectedLabelPlural : selectedLabelSingular;
      return selected.length !== 0 ? "".concat(selected.length, " ").concat(selectedLabel, " selected") : void 0;
    }
    var _Children$toArray$fil3 = import_react.Children.toArray(props.children).filter(function(child) {
      if (/* @__PURE__ */ (0, import_react.isValidElement)(child)) {
        return child.props.value === selected[0];
      }
      return false;
    }), _Children$toArray$fil4 = _slicedToArray(_Children$toArray$fil3, 1), selectedOptionFullInfo = _Children$toArray$fil4[0];
    if (props.handleSelection) {
      customSelectedValue = /* @__PURE__ */ (0, import_react.isValidElement)(selectedOptionFullInfo) ? props.handleSelection(selectedOptionFullInfo.props) : "";
      return customSelectedValue;
    }
    return /* @__PURE__ */ (0, import_react.isValidElement)(selectedOptionFullInfo) ? selectedOptionFullInfo.props.children : selected[0];
  };
  var getInputValue = function getInputValue2() {
    if (showFilterVal) {
      return filterVal;
    }
    return selected.length ? getSelectedValue() : "";
  };
  var handleClick = function handleClick2() {
    if (!disabled) {
      setOpen(!open);
    }
    return false;
  };
  return /* @__PURE__ */ import_react.default.createElement(SearchComboboxContext.Provider, {
    value: dataContext
  }, /* @__PURE__ */ import_react.default.createElement(import_InputCombobox.StyledComboboxContainer, {
    className: "input-combobox-container ".concat(props.className),
    "data-testid": "combobox-container",
    ref: containerRef
  }, /* @__PURE__ */ import_react.default.createElement(import_InputCombobox.StyledSearchContainer, {
    "aria-disabled": disabled,
    darkMode,
    isDisabled: disabled,
    error,
    borderLess,
    onClick: handleClick,
    className: "search-container",
    "data-testid": "search-container",
    "data-dp-analytics-id": props.dataDpAnalyticsId,
    tabIndex: disabled ? 0 : void 0
  }, props.comboboxIcon && /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
    icon: props.comboboxIcon,
    size: 18,
    className: "select__icon"
  }), /* @__PURE__ */ import_react.default.createElement(import_InputCombobox.StyledInputLayout, {
    className: "select__layout",
    active: inputActive || Boolean(selected === null || selected === void 0 ? void 0 : selected.length),
    "data-testid": "combobox-inputlayout"
  }, props.label && /* @__PURE__ */ import_react.default.createElement(import_InputCombobox.StyledLabel, {
    htmlFor: IDLIST.input_id,
    className: "select__label",
    id: IDLIST.search_label,
    "data-testid": "combobox-label"
  }, props.label, required && /* @__PURE__ */ import_react.default.createElement("span", {
    "aria-hidden": true
  }, "*")), /* @__PURE__ */ import_react.default.createElement(import_InputCombobox.StyledInput, {
    id: IDLIST.input_id,
    onFocus: function onFocus() {
      return setInputActive(true);
    },
    placeholder: inputActive ? placeholder : null,
    darkMode,
    disabled,
    onChange: handleInputChange,
    ref: inputRef,
    role: "combobox",
    className: "select__input",
    autoComplete: "off",
    size: props.inputSize,
    value: getInputValue(),
    "data-testid": "select-input",
    "aria-required": required && true,
    "aria-describedby": IDLIST.error,
    "aria-label": props.label,
    "aria-haspopup": "listbox",
    "aria-expanded": open,
    "aria-controls": IDLIST.combobox_id
  })), /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
    icon: open ? "chevron-up" : "chevron-down",
    size: 20,
    className: "select__chevron",
    color: import_baseTheme.default.colors.pr.base
  })), (open && !filterVal || open && filterVal && filteredChildren.length > 0) && /* @__PURE__ */ import_react.default.createElement(import_ComboboxListBox.ComboboxListBox, {
    activeDescendant,
    labelledBy: IDLIST.search_label,
    id: IDLIST.combobox_id,
    ref: listboxRef,
    "data-testid": "combobox-listbox"
  }, filteredChildren.length && !!filterVal ? filteredChildren : props.children), /* @__PURE__ */ import_react.default.createElement(import_InputCombobox.StyledErrorContainer, {
    darkMode,
    "aria-live": "assertive",
    id: IDLIST.error
  }, error && errorText && /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(import_InputCombobox.StyledIcon, {
    icon: "warning",
    ariaHidden: true
  }), /* @__PURE__ */ import_react.default.createElement("span", null, errorText)))));
};
InputCombobox.Option = import_Option.Option;
InputCombobox.AllOptions = import_AllOptions.AllOptions;
var InputCombobox_component_default = InputCombobox;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  UseInputComboboxCtx
});
//# sourceMappingURL=InputCombobox.component.js.map